module.exports = __webpack_public_path__ + "static/media/brake-fluid-exchange.5f36ef67.svg";